// File: app/src/components/workout/RepsAdjustSheet.js
//
// Reps actually done on the set just finished (#97). Done on a reps step
// records the prescribed reps; when a set fell short (or went over), the user
// corrects it here during the rest that follows. A bottom sheet with Done in
// thumb reach and the draggable stepper, as elsewhere on mobile.

import React, { useEffect, useState } from "react";
import DetailSheet from "../session/generate/DetailSheet";
import DraggableStepper from "../ui/draggable-stepper";

const RepsAdjustSheet = ({ open, onOpenChange, set, onSubmit }) => {
  const [reps, setReps] = useState(0);

  // Seed from the set each time the sheet opens.
  useEffect(() => {
    if (open && set) setReps(set.actual ?? set.prescribed ?? 0);
  }, [open, set]);

  if (!set) return null;

  const close = (next) => {
    if (!next) {
      if (reps !== set.actual) onSubmit(set.index, reps);
      onOpenChange(false);
    }
  };

  return (
    <DetailSheet
      open={open}
      onOpenChange={close}
      title={`Reps for set ${set.setNumber}`}
      description={`${set.label}: ${set.prescribed} prescribed`}
      showDescription
    >
      <DraggableStepper
        label="Reps done"
        value={reps}
        onChange={setReps}
        min={0}
        max={Math.max(50, set.prescribed * 3)}
        step={1}
        unit="reps"
      />
    </DetailSheet>
  );
};

export default RepsAdjustSheet;
